/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pricing_BadgeInputs */

const zh_pricing_badge = /** @type {(inputs: Pricing_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`简单透明`)
};

const en_pricing_badge = /** @type {(inputs: Pricing_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simple & Transparent`)
};

const es_pricing_badge = /** @type {(inputs: Pricing_BadgeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Simple y Transparente`)
};

/**
* | output |
* | --- |
* | "Simple & Transparent" |
*
* @param {Pricing_BadgeInputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pricing_badge = /** @type {((inputs?: Pricing_BadgeInputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pricing_BadgeInputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_pricing_badge(inputs)
	if (locale === "en") return en_pricing_badge(inputs)
	return es_pricing_badge(inputs)
});